// Generated by scripts/build-ui-icons.mjs.
export { SlidersHorizontal as default } from "../ui/glyphs-7";
